import React, { useEffect, useState, useRef } from 'react';
import {SvgDelete} from '../../Svg.js';

function AnuForm({id, ai}) {
	
  const [clientes, setClientes] = useState([]);

  const idInputRef = useRef(null); 


  const [optionsPagamentos, setoptionsPagamentos] = useState([]); 
	  useEffect(() => {
		fetch("http://localhost:3001/cr_obj?obj=Pagamentos")
		  .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
			return response.json();})
		  .then((data) => { setoptionsPagamentos(data.cr_obj); })
		  .catch((error) => console.error("Erro ao buscar os dados:", error));
	  }, [id]);
	
  
const [optionsParcelas, setoptionsParcelas] = useState([]); 
	  useEffect(() => {
		fetch("http://localhost:3001/cr_obj?obj=ParcelaAnu")
		  .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
			return response.json();})
		  .then((data) => { setoptionsParcelas(data.cr_obj); })
		  .catch((error) => console.error("Erro ao buscar os dados:", error));
	  }, [id]);


	  const handleDelete = async (ordem, id) => {
		const resposta = window.confirm("Exclur o HD: "+ordem+"?");
		if (resposta) {
			console.log("Usuário escolheu SIM!");
		} else {
			console.log("Usuário escolheu NÃO!");
		}
	}


  useEffect(() => {
	if (idInputRef.current) {
	  console.log("Referência inicializada:", idInputRef.current);
	}
  }, []);

  const handleFocus = () => {
	if (idInputRef.current) {
	  idInputRef.current.focus();
	} else {
	  console.log("Referência não está disponível!");
	}
  };

  const [formData, setFormData] = useState({
	id: ""
  });

  formData.codigo = id;

  const handleChange = (e) => {
  const { name, value, checked, type } = e.target; 
	setFormData({ ...formData, [name]: type === "checkbox" ? checked : value});
	setFormData((prevData) => ({
	  ...prevData,
	  [name]: value
	}));
  };

  const handleSubmit = async (e) => {
	e.preventDefault();
	const params = new URLSearchParams();
	for (const key in formData) {
	  if (key === "Situacao")  {
		if (formData[key] === "") {
		  formData[key] = "Ativo"; }};
		params.append(key, formData[key]);
	}
	console.log('params----->', params, formData);

	if (!id) {
	  id = formData.id;
	}
   
	const response = await fetch(`http://localhost:3001/cr_pag_Id/${id}/${ai}`, {
	  method: "PUT",
	  headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify(formData),
	});
	if (response.status === 200) {
		window.location.href = "./PagGrid";
	} else {
	  console.error('Erro ao ATUALIZAR cliente:', response.status);
	  alert('Erro ao ATUALIZAR-POST Cr_Pag.'+response.status);
	}
	const data = await response.json();
  };

  useEffect(() => {
	if (ai ==="I") {
		fetch("http://localhost:3001/cr_cont?id=pag")
	  .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
		return response.json();})
	  .then((data) => { formData.id = data.cr_cont.id; 
	   })
	  .catch((error) => console.error("Erro ao buscar os dados:", error));
	}
  }, [id, ai, formData]);

	useEffect(() => {
		fetch(`http://localhost:3001/cr_pag_Id?id=${id}`)
			.then(response => {
				if (!response.ok) {
				throw new Error("Erro ao buscar os dados!");
				}
				return response.json();
			})
			.then(data => {
				setFormData(prevState => ({ ...prevState, 
				id:data.cr_pag.id
				})); 
			})
			.catch(error => console.error("Erro ao buscar os dados:", error));
		}, [id, ai] );

  //handleFocus();

return (
<><div class="areabox">
	<br/>


		<table border={2}>
			<tr>
				<td>
				<label for="id" class="form-control">Código:</label><br/>  
        <input type="text" class="w15 fs1" id="id" name="id"  value={formData.id} onChange={handleChange}  />
				</td>
				<td colspan="3">
				<label for="nome" class="form-control ">Identificação:</label><br/>      
        <input type="text" class="w45 fs1" id="nome" name="nome" value={formData.nome} onChange={handleChange} ref={idInputRef}/>

				</td>
			</tr>
			<tr>
				<td colspan="2">
					
		<label for="pagamento" class="form-control">Descontos:</label><br/>  
        <select class="w45 fs2" id="pagamento" name="pagamento" value={formData.pagamento} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsPagamentos) && optionsPagamentos.length > 0 ? (
        optionsPagamentos.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>


				</td>
				<td colspan="2">
					

		<label for="pagamento" class="form-control">Pagamentos:</label><br/>  
        <select class="w45 fs2" id="pagamento" name="pagamento" value={formData.pagamento} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsPagamentos) && optionsPagamentos.length > 0 ? (
        optionsPagamentos.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>


				</td>
			</tr>
			<tr>
				<td>
					
		<label for="parcelas" class="form-control">Parcelas:</label><br/>  
        <select class="w20 fs2" id="parcelas" name="parcelas" value={formData.pagamento} onChange={handleChange}>
        <option value=""></option>
        {Array.isArray(optionsParcelas) && optionsParcelas.length > 0 ? (
        optionsParcelas.map((option, index) => (
        <option key={index} value={option.Nome}>
        {option.Nome}
        </option>
        ))
        ) : (      <option value="">Nenhum tipo disponível</option>      )}
        </select>
        <br/>

				</td>
				<td> </td>
				<td>
				<br/>
				<input type="checkbox" id="ativo"      name="ativo"      checked={formData.ativo} onChange={handleChange}/>
    <label for="ativo" class="form-control">Ativo</label><br/>

				</td>
				<td> </td>
			</tr>
			<tr>
				<td colspan="4">
				<h2>Grid de  itens</h2>


				<table class="tableGrid">
        <thead>
          <tr>
            <th>Ordem</th>
            <th>HD</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr key={cliente.Ordem}>
              <td>{cliente.Ordem}</td>
              <td>{cliente.HD}</td>
              <td>
              &nbsp;&nbsp;<a href="#Aqui" onClick={() => handleDelete(cliente.Ordem, cliente.Id)}><SvgDelete/></a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>




				</td>
			</tr>
		</table>


	<br/>
	<button type="submit" class="botaovermelho">Confirmar</button>
	<button type="button" className="botaocinza" onClick={() => {window.location.href = "./AnuGrid"; }}>Cancelar</button>&nbsp;
</div></>
)    
};

export default AnuForm;

